import React from 'react';
import { motion } from 'framer-motion';
import arrow from '../assets/arrow-circle-up-right-svgrepo-com.svg'
const ProjectCard = ({  bgPic, projectStatus,title }) => {
    const itemVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.5, // Adjust the duration as needed
          },
        },
      };

  return (
    <motion.div
      className="w-full h-[410.68px] bg-white rounded-[30px] p-6 hover:animate-pulse relative cursor-pointer"
      style={{
        backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.7) 100%), url(${bgPic})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      variants={itemVariants}
    >
      <motion.div
        className="w-full h-full flex justify-between"
        initial="hidden"
        animate="visible"
      >
        <p className="pro-stat text-[23px] text-white leading-[24px]">{projectStatus}</p>
        <img src={arrow} className="w-8 h-8" alt="" />
      </motion.div>
      <motion.div
        className="text-[48px] leading-[48px] pro-tit absolute bottom-16 left-8"
        initial="hidden"
        animate="visible"
      >
       {title}
      </motion.div>
    </motion.div>
  );
};

export default ProjectCard;
